import api from "./API";

/**
 * Department Service
 * API service for managing departments (formerly patients)
 */

export const departmentService = {
  /**
   * Get all departments with optional filters and pagination
   * @param {Object} params - Query parameters (page, limit, search, departmentType, etc.)
   * @returns {Promise} API response with departments list
   */
  getDepartments: (params) => api.get("/department/list", { params }),


  

  /**
   * Get stock allocated to a specific department
   * @param {string} id - Department ID
   * @returns {Promise} API response with department stock information
   */
  getDepartmentStock: (id) => api.get(`/departments/${id}/stock`),

  /**
   * Get consumption statistics for a department
   * @param {string} id - Department ID
   * @param {Object} params - Query parameters (startDate, endDate, itemType, etc.)
   * @returns {Promise} API response with consumption data
   */
  getDepartmentConsumption: (id, params = {}) => 
    api.get(`/departments/${id}/consumption`, { params }),
};


